import { PlusSquareIcon } from '@phosphor-icons/react';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { PageHeader } from '@/modules/common';
import { useTableStore } from '@/modules/common/store';
import { Routes } from '@/router/routes';

import { useCreateEvent } from '../api';
import { EventForm } from '../components';

export const NewEventPage: FC = () => {
  const navigate = useNavigate();
  const { setSearchValue } = useTableStore();

  const {
    createEventMutation,
    uploadUrlData,
    isFetching,
    refetchUploadUrl,
    refetchIdleStateUploadUrl,
  } = useCreateEvent();

  const saveEvent = async (data) => {
    if (uploadUrlData?.eventId) {
      try {
        await createEventMutation.mutateAsync({
          ...data,
          id: uploadUrlData.eventId,
          masks: data.masks.map((mask) => ({
            maskId: mask.maskId,
            overlays: mask.overlayId ? [{ overlayId: mask.overlayId }] : [],
          })),
        });
        navigate(Routes.Events, { replace: true });
        toast.success(`Event “${data.name}” added successfully!`);
      } catch (error) {
        console.error(error.message);
      }
    }
  };

  const refetchUploadCredentials = async () => {
    try {
      await refetchUploadUrl();
      await refetchIdleStateUploadUrl();
    } catch (error) {
      toast.error('Uh oh! Something went wrong.');
    }
  };

  const handleBack = () => {
    setSearchValue('');
  };

  return (
    <EventForm
      onSubmit={saveEvent}
      uploadUrlData={uploadUrlData}
      refetchUploadCredentials={refetchUploadCredentials}
    >
      {({ isLoading }) => (
        <PageHeader
          title="New Event"
          asChildPage
          onBack={handleBack}
          backPath={Routes.Events}
          actions={[
            <Button
              key="create-event"
              data-testid="create-event-button"
              type="submit"
              isLoading={
                isFetching || createEventMutation.isPending || isLoading
              }
              startIcon={<PlusSquareIcon />}
            >
              Create new event
            </Button>,
          ]}
        />
      )}
    </EventForm>
  );
};
